import React, { useEffect } from "react";
import "./style.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { LOGOUT } from "../../redux/actions";

import LoadingSpinner from "../../elements/loading-spinner";

const LogoutCustomer = ({ rendering, logout, lang }) => {
  useEffect(() => {
    logout();
    window.location.href = `/${lang}`;
  }, []);

  return (
    <div className="logout-customer" datasourceid={rendering.dataSource}>
      <LoadingSpinner />
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch({ type: LOGOUT })
});
export default connect(null, mapDispatchToProps)(LogoutCustomer);

LogoutCustomer.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string })
};
